module.exports = __webpack_public_path__ + "static/media/nutrition-and-calories-tracker.b16c54ac.jpg";